/**
 * Available types for a field metadata.
 * @public
 */
export var FieldTypeEnum;
(function (FieldTypeEnum) {
    FieldTypeEnum["STRING"] = "STRING";
    FieldTypeEnum["NUMBER"] = "NUMBER";
    FieldTypeEnum["BOOLEAN"] = "BOOLEAN";
    FieldTypeEnum["ENUM"] = "ENUM";
    FieldTypeEnum["DATE"] = "DATE";
    FieldTypeEnum["DATETIME"] = "DATETIME";
    FieldTypeEnum["CUSTOM"] = "CUSTOM";
})(FieldTypeEnum || (FieldTypeEnum = {}));
/**
 * Types map for FieldTypeEnum.
 * @public
 */
export const TYPES_MAP = {
    STRING: FieldTypeEnum.STRING,
    ENUM: FieldTypeEnum.ENUM,
    BOOLEAN: FieldTypeEnum.BOOLEAN,
    INT: FieldTypeEnum.NUMBER,
    LONG: FieldTypeEnum.NUMBER,
    DOUBLE: FieldTypeEnum.NUMBER,
    BIGDECIMAL: FieldTypeEnum.NUMBER,
    DATE: FieldTypeEnum.DATE,
    DATETIME: FieldTypeEnum.DATETIME,
};
